export interface IColumnFilterOptions<Item> {
  enabled?: boolean; // defaults to true
  type?: 'input' | 'datepicker' | 'boolean' | 'select' | 'autocomplete';
  filterName?: string;
  filterGetter?: string | ((item: Item) => string);
  filterWith?: filterFunction;
  selectOptions?: { [value: string]: string }; // For when type is 'select'
  initial?: string;
}

export interface IFilterOptions {
  enabled?: boolean; // defaults to false
  remoteFiltering?: boolean;
  debounce?: number;
  excludeEmpty?: boolean;
}

export type filterFunction = (value: any, filter: any) => boolean; // eslint-disable-line @typescript-eslint/no-explicit-any

export const filter: filterFunction = (value, filter) => {
  return String(value).toLowerCase().includes(String(filter).toLowerCase());
};

export const fuzzy: filterFunction = (value, filter) => {
  return !!String(value).match(new RegExp(filter.split('').join('.*'), 'i'));
};
